import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {TabContent, TabPane} from "reactstrap";
import "./index.css";
import AttachmentPublishedContentTab from "./published-content";
import AttachmentMyLibraryTab from "./my-library";

class AttachmentTabContent extends Component {

    constructor(props) {
        super(props);
        this.state = {}

    }

    componentDidMount() {

    }

    UNSAFE_componentWillReceiveProps(nextProps) {

    }


    render() {
        return (
            <TabContent activeTab={this.props.activeTab} style={{marginLeft: -21}}>
                <AttachmentPublishedContentTab
                    broadcaster={this.props.broadcaster}
                    setSelectedItem={this.props.setSelectedItem}
                    selectedItems={this.props.selectedItems}
                    activeTab={this.props.activeTab}
                />
                <AttachmentMyLibraryTab
                    broadcaster={this.props.broadcaster}
                    setSelectedItem={this.props.setSelectedItem}
                    selectedItems={this.props.selectedItems}
                    activeTab={this.props.activeTab}
                />
                <TabPane tabId="pc">PC</TabPane>
            </TabContent>
        );
    }
}

AttachmentTabContent.propTypes = {
    activeTab: PropTypes.string.isRequired,
};

export default AttachmentTabContent;
